// 根级菜单
import HomeView from "@/views/home/HomeView.vue";
import IframeLayout from "@/layouts/IframeLayout.vue";

const generateRootRouter = ()=> {
  return {
    path: '/home',
    name: 'AppHome',
    component: HomeView,
    meta: {title: '首页', keepAlive: true},
    children: []
  }
}

/**
 * 动态生成菜单
 */
export const generatorDynamicRouter = appList => {
  const rootRouter = generateRootRouter()
  const routerList = []
  appList.forEach(app => {
    const currentRouter= {
      // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
      path: `workplace/app/${app.code}`,
      // 路由名称，建议唯一
      name: app.code,
      // 该路由对应页面的 组件 :方案1
      // component: constantRouterComponents[item.component || item.key],
      // 该路由对应页面的 组件 :方案2 (动态加载)
      component: IframeLayout,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: app.name,
        type: 'app',
        url: app.pcUrl,
        icon: app.icon
      }
    }
    routerList.push(currentRouter)
  })
  rootRouter.children = routerList
  return rootRouter
}
